/*
 * Public API Surface of cmyd-base-service
 */

export * from './lib/cmyd-base-service.service';
export * from './lib/interfaces/CmydIResponseBase';
export * from './lib/interfaces/CmydIResponsePagedBase';
export * from './lib/cmyd-base-service.module';
